<template>
    <div class="mb-4">
        <label class="flex my-2">
            <div class="bg-white rounded border-accor w-4 h-4 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
                <input type="checkbox" v-model="publicOffer" class="opacity-0 absolute">
                <svg class="hidden w-3 h-3 pointer-events-none" fill="#2c7a7b" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
            <div
                class="select-none text-xs leading-tight font-light"
                :class=" (!publicOffer && checkBoxError) ? 'text-red-500':''">
                    {{ $root.getKeyWord('byorderingservice') }}
                    <a class="text-accor" @click="$modal.show('modal-agreement'); $root.getPublicInformation('full_agreement')" href="javascript:void(0)">{{ $root.getKeyWord('ofthepublicoffer') }}</a>

                ({{ $root.getKeyWord('byclickingorder') }}
                <a class="text-accor"  @click="$modal.show('modal-agreement'); $root.getPublicInformation('full_agreement')" href="javascript:void(0)">{{ $root.getKeyWord('thepublicoffer') }}</a>
                ).
            </div>
        </label>
        <label class="flex my-2">
            <div class="bg-white rounded border-accor w-4 h-4 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
                <input type="checkbox" v-model="privacyPolicy" class="opacity-0 absolute">
                <svg class="hidden w-3 h-3 pointer-events-none" fill="#2c7a7b" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
            <div
                class="select-none text-xs leading-tight font-light" :class="(!privacyPolicy && checkBoxError) ? 'text-red-500':''">
                {{ $root.getKeyWord('ireadaccepted') }}
                <a class="text-accor" @click="$modal.show('modal-privacy-policy'); $root.getPublicInformation('privacy_policy')" href="javascript:void(0)">{{ $root.getKeyWord('privacy_policy') }}</a>
                {{ $root.getKeyWord('personal_data_processing') }}
            </div>

        </label>

        <div  class="text-gray-800 text-xs  font-light">
            {{ $root.getKeyWord('emailsending') }}
            <a class="text-accor" href="mailto:privacy@dgstay.com">privacy@dgstay.com</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        checkAgreement: {
            type:Boolean,
            required: false,
        },
        checkBoxError: {
            type: Boolean,
            required: false,
        },
    },

    data() {
        return {
            publicOffer: false,
            privacyPolicy: false,
        }
    },

    watch: {
        publicOffer() {
            this.$emit('update:checkAgreement', this.publicOffer && this.privacyPolicy);
        },

        privacyPolicy() {
            this.$emit('update:checkAgreement', this.publicOffer && this.privacyPolicy);
        }
    },
}
</script>

<style scoped>
    .border-accor {
        border: 1px solid #2c7a7b;
    }

    .text-accor {
        color: #2c7a7b;
    }

    input:checked + svg {
        display: block;
    }
</style>